<div style="width: 500px">
  <div class="grid grid-cols-2 gap-7">
    <div>
      <aux-input
        label="Note"
        inputClassName="grow resize-none"
        style="display: flex"
        class="h-full flex-col text-xs"
        [textArea]="true"
        resize="none"
        [rows]="2"
        [validators]="'required'"
        [formControl]="textarea"
        [showRequiredAsterisk]="true"
      />

      <div class="max-h-60 space-y-2.5 overflow-auto">
        @for (note of notes; track note) {
          <div class="border-l-4 border-aux-blue-dark pl-3">
            <div class="italic">
              {{ note.username }} - {{ note.create_date | date: 'dd MMMM y' }}:
            </div>
            <div>"{{ note.message }}"</div>
          </div>
        }
      </div>
    </div>
    <div>
      <p class="mb-1 block text-xs">Supporting Documents</p>
      <aux-file-manager
        #fileManager
        class="h-32"
        [fetchFilesOnInit]="false"
        [pathFn]="pathFn()"
        [eager]="false"
        [metadata]="metadata"
        [insertDocument]="false"
      />
      <aux-file-manager-uploaded-files [fileManager]="fileManager" />
    </div>
  </div>
</div>
